import 'core-js/es6/map';
import 'core-js/es6/set';
import 'core-js/es6/weak-set';
// import "babel-polyfill"
import 'raf/polyfill';

import React from 'react'
import ReactDOM from 'react-dom'
import graphql from 'babel-plugin-relay/macro'
import { Resolver } from 'found-relay'
import { ScrollManager } from 'found-scroll'
import { BrowserProtocol, queryMiddleware } from 'farce'
import ElementsRenderer from 'found/lib/ElementsRenderer'
import { Route, makeRouteConfig, createRender, createFarceRouter } from 'found'

import Environment from './environment'
import RouteResolver from './route-resolver'
// import registerServiceWorker from './registerServiceWorker'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import Preview from './preview'
import App from './containers/app/app'
import HomePage from './containers/home-page/home-page'
import CityPage from './containers/city-page/city-page'
import AboutPage from './containers/about-page/about-page'
import ErrorPage from './containers/error-page/error-page'
import SearchPage from './containers/search-page/search-page'
import FormPage from './containers/form-page/form-page'
import FormPaperformPage from './containers/form-page/form-paperform-page'
import PartnershipPage from './containers/partnership-page/partnership-page'
import AmpBuilderPage from './containers/amp-article-page/amp-article-page'
import ArticlePage from './containers/article-page/article-page'
import CategoryPage from './containers/category-page/category-page'
import ProductPage from './containers/online-store-page/product-page'
import CityListPage from './containers/city-list-page/city-list-page'
import SharedBookPage from './containers/shared-book-page/shared-book-page'
import OnlineStorePage from './containers/online-store-page/online-store-page'
import PhysicalStorePage from './containers/physical-store-page/physical-store-page'
import StoreDetailPage from './containers/physical-store-page/store-detail-page'
import CategoryListPage from './containers/category-page/category-list-page'
import redirects from "./_redirects.json"

import './webflow-normalize.css'
import './webflow-components.css'
import './webflow-style.css'
import './custom-style.css'

const AppQuery = graphql`query srcAppQuery { ...app_query }`
const HomePageQuery = graphql`query srcHomePageQuery { home { ...homePage_home } }`
const CityListQuery = graphql`query srcCityListQuery { ...cityListPage_query }`
const CityQuery = graphql`query srcCityQuery($slug: String!) { city(slug: $slug) { ...cityPage_city } }`
const SharedBookQuery = graphql`query srcSharedBookQuery($slug: String!) { sharedBook(slug: $slug) { ...sharedBookPage_sharedBook } }`
const ArticleQuery = graphql`query srcArticleQuery($slug: String!) { article(slug: $slug) { ...articlePage_article } }`
const CategoryListQuery = graphql`query srcCategoryListQuery { ...categoryListPage_query }`
const CategoryQuery = graphql`query srcCategoryQuery($slug: String!) { category(slug: $slug) { ...categoryPage_category } }`
const OnlineStoreQuery = graphql`query srcOnlineStoreQuery { onlineStore { ...onlineStorePage_onlineStore } }`
const ProductQuery = graphql`query srcProductQuery($slug: String!) { product(slug: $slug) { ...productPage_product } }`
const AmpArticleQuery = graphql`query srcAmpArticleQuery {
  articles(first: 10000) {
    publishedAt
    slug
    title
    forceTitleToAppearUnderneath
    caption
    readingTime
    picture
    widePicture
    videoLink
    author {
      firstname
      lastname
      biography
      picture
      facebook
      twitter
      instagram
      website
    }
    sponsor {
      name
      description
      logo
    }
    city {
      slug
      name
      color
      articles(first: 7) {
        slug
        title
        caption
        readingTime
        picture
        author {
          firstname
          lastname
        }
      }
    }
    cities {
      slug
      name
      color
      articles(first: 7) {
        slug
        title
        caption
        readingTime
        picture
        author {
          firstname
          lastname
        }
      }
    }
    category {
      slug
      name
      color
      articles(first: 7) {
        slug
        title
        caption
        readingTime
        picture
        author {
          firstname
          lastname
        }
      }
    }
    slices {
      type
      intro {
        initialLetter
        text
      }
      pictureDuo {
        picture
        caption
      }
      inlinePicture {
        picture
        caption
      }
      highlightedPicture {
        picture
        caption
      }
      quote
      embed
      paragraph {
        type
        text
        spans {
          start
          end
          type
          data {
            id
            uid
            type
            slug
            link_type
            url
          }
        }
      }
      textPicture {
        picture
        content {
          type
          text
          label
          spans {
            data {
              id
              uid
              type
              slug
              url
              link_type
            }
            start
            end
            type
          }
        }
      }
    }
    seo {
      title
      description
    }
    social {
      twitter {
        type
        title
        image
        handle
        description
      }
      generic {
        title
        image
        description
      }
    }
  }
}`
const StoreContentQuery = graphql`query srcStoreContentQuery {
  storecontent{
    banner
    stores{
      uid
      slug
      name
      color
      preview{
        cover
        title
        address
      }
      seo{
        title
        description
      }
    }
    products{
      name
      description
      type
      link
      picture
    }
    maincontent{
      mainpicture
      maindescription
      mainhighlight
      intro
      footer_product_image
    }
    seo {
      title
      description
    }
    social {
      twitter {
        type
        title
        image
        handle
        description
      }
      generic {
        title
        image
        description
      }
    }
    partnercontent{
      partnerpicture
      partnertitle
      partnerdescription
    }
    contactevent{
      title
      description
      contact
    }
    contactproduct{
      title
      description
      contact
    }
  }
}`
const StoreDetailQuery = graphql`query srcStoreDetailQuery($slug: String!) {
  store(slug:$slug){
    name
    color
    uid
    slug
    details{
      cover
      description{
        type
        text
        spans{
          start
          end
          type
          data{
            id
            uid
            url
            type
            slug
            link_type
          }
        }
      }
      video
      phone
      email
      operatinghours
      gallery
    }
    seo{
      title
      description
    }
    social{
      generic{
        title
        description
        image
      }
      twitter{
        type
        title
        description
        handle
        image
      }
    }
    preview{
      address
    }
    products {
      picture
      name
      description
      type
      link
    }
    structured_data {
      street_address
      address_locality
      postal_code
      address_country
      same_as
      price_range
      geo {
        latitude
        longitude
      }
      openingHours{
        open
        close
        days_of_week
      }
    }
  }
}`
const AboutPageQuery = graphql`
  query srcAboutPageQuery {
    about{
      banner
      story{
        type
        section{
          title
          paragraph{
            content{
              type
              text
              spans{
                start
                end
                type
                data{
                  id
                  uid
                  url
                  type
                  slug
                  link_type
                }
              }
              label
            }
          }
          picture
        }
        inlinePicture{
          picture
          caption
        }
        pictureDuo{
          picture
          caption
        }
      }
      team{
        type
        teamMember{
          portrait
          name
          occupation
          location
          description
          facebook
          twitter
          instagram
          linkedin
          website
        }
        paragraph{
          content{
            type
            text
            spans{
              start
              end
              type
              data{
                id
                uid
                url
                type
                slug
                link_type
              }
            }
          }
        }
      }
      contact{
        type
        contactBox{
          title
          description
          email
          phone
          link
        }
        visit{
          place_name
          address
          email
          phone
          working_hours
          map{
            latitude
            longitude
          }
        }
      }
      seo{
        title
        description
      }
      social{
        generic{
          title
          description
          image
        }
        twitter{
          type
          title
          description
          handle
          image
        }
      }
    }
  }
`;

const routes = makeRouteConfig(
  <Route path={RouteResolver.root.path}>
    <Route path="/preview" render={routeProps => <Preview {...routeProps} />} />
    <Route path="/partnership" Component={PartnershipPage} />
    <Route path="/amp-builder" query={AmpArticleQuery} Component={AmpBuilderPage} />
    <Route path={RouteResolver.sharedBook.path} query={SharedBookQuery} Component={SharedBookPage} />
    <Route query={AppQuery} Component={App}>
      <Route query={HomePageQuery} Component={HomePage} />
      <Route path={RouteResolver.search.path} Component={SearchPage} />
      <Route path={RouteResolver.form.path} Component={FormPage} />
      <Route path={RouteResolver.formP.path} Component={FormPaperformPage} />
      <Route path={RouteResolver.about.path} query={AboutPageQuery} Component={AboutPage} />
      <Route path={RouteResolver.categoryList.path} query={CategoryListQuery} Component={CategoryListPage} />
      <Route path={RouteResolver.category.path} query={CategoryQuery} Component={CategoryPage} />
      <Route path={RouteResolver.onlineStore.path} query={OnlineStoreQuery} Component={OnlineStorePage} />
      <Route path={RouteResolver.stores.path} query={StoreContentQuery} Component={PhysicalStorePage} />
      <Route path={RouteResolver.store.path} query={StoreDetailQuery} Component={StoreDetailPage} />
      <Route path={RouteResolver.product.path} query={ProductQuery} Component={ProductPage} />
      <Route path={RouteResolver.locations.path} query={CityListQuery} Component={CityListPage} />
      <Route path={RouteResolver.location.path} query={CityQuery} Component={CityPage} />
      <Route path={RouteResolver.article.path} query={ArticleQuery} Component={ArticlePage} />
    </Route>
  </Route>
)

const Router = createFarceRouter({
  historyProtocol: new BrowserProtocol(),
  historyMiddlewares: [queryMiddleware],
  routeConfig: routes,
  render: createRender({
    renderReady: (renderArgs) => {
      var routeRedirect = Object.keys(redirects).indexOf(renderArgs.location.pathname)
      // console.log(renderArgs)
      if (routeRedirect !== -1) {
        renderArgs.router.push(redirects[renderArgs.location.pathname]);
      }

      return (
        <ScrollManager renderArgs={renderArgs}>
          <ElementsRenderer elements={renderArgs.elements} />
        </ScrollManager>
      )
    },
    renderError: (renderArgs) => {
      var routeRedirect = Object.keys(redirects).indexOf(renderArgs.location.pathname)
      // console.log(renderArgs)
      if (routeRedirect !== -1) {
        renderArgs.router.push(redirects[renderArgs.location.pathname]);
        return null
      }
      return <ErrorPage {...renderArgs} />
    }
  })
})

ReactDOM.render(

  <Router
    matchContext={{ routeResolver: RouteResolver }}
    resolver={new Resolver(Environment)}
  />,

  document.getElementById('root')
)

setTimeout(() => {
  let script = document.createElement("script")
  script.src = '/webflow.min.js'
  document.body.appendChild(script)
  let script_instagram = document.createElement("script")
  script_instagram.src = 'https://www.instagram.com/embed.js'
  script.onerror = function () {
    document.querySelector('.instagram-media').parentNode.parentNode.parentNode.parentNode.parentNode.remove()
  }
  document.body.appendChild(script_instagram)
}, 2500)

serviceWorkerRegistration.register();

if (window.location.pathname === "/amp-builder") {
  window.prerenderReady = false

  var sc = document.createElement("meta");
  sc.setAttribute("name", "fragment");
  sc.setAttribute("content", "!");
  document.head.appendChild(sc);
}